export interface IMetadataData {
    bannerUrl?: string;
    imageUrl?: any[];
    bannerType?: string;
    categorylv1Id?: number;
    categorylv1Name?: string;
    description?: string;
    startDate?: number;
    endDate?: number;
    slotIndex?: number;
    show?: boolean;
    badgeLeft?: string;
    BadgeLeft?: string;
    preType?: string;
    deliveryDate?: number;
    preRelativeDay?: number;
    preQtyPerDay?: number;
    two4?: boolean;
}

export interface IMetadata extends IMetadataData {
    data(): IMetadataData
}
export class Metadata implements IMetadata {
    bannerUrl?: string;
    imageUrl?: any[];
    bannerType?: string;
    categorylv1Id?: number;
    categorylv1Name?: string;
    description?: string;
    startDate?: number;
    endDate?: number;
    slotIndex?: number;
    show?: boolean;
    badgeLeft?: string;
    preType?: string;
    deliveryDate?: number;
    preRelativeDay?: number;
    preQtyPerDay?: number;
    two4?: boolean;

    constructor(data: IMetadataData) {
        this.bannerUrl = data.bannerUrl
        this.imageUrl = data.imageUrl?.map((i) => i)
        this.bannerType = data.bannerType
        this.categorylv1Id = data.categorylv1Id
        this.categorylv1Name = data.categorylv1Name
        this.description = data.description
        this.startDate = data.startDate
        this.endDate = data.endDate
        this.slotIndex = data.slotIndex
        this.show = data.show
        this.badgeLeft = data.BadgeLeft || data.badgeLeft
        if (data.preType) {
            // console.log("create meta:", data)
            this.preType = data.preType
            this.deliveryDate = data.deliveryDate
            this.preRelativeDay = data.preRelativeDay
            this.preQtyPerDay = data.preQtyPerDay
        }
    }

    data(): IMetadataData {
        throw new Error("Method not implemented.");
    }

}